'use strict';exports.__esModule = true;exports.formatPropertyDescription = exports.formatProjectTitle = exports.formatPropertyTitle = exports.formatSearchDescription = exports.formatSearchTitle = exports.composeEnglishSearchTitle = exports.composeHebrewSearchTitle = undefined;var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _head = require('lodash/head');var _head2 = _interopRequireDefault(_head);
var _last = require('lodash/last');var _last2 = _interopRequireDefault(_last);
var _upperFirst = require('lodash/upperFirst');var _upperFirst2 = _interopRequireDefault(_upperFirst);
var _lowerFirst = require('lodash/lowerFirst');var _lowerFirst2 = _interopRequireDefault(_lowerFirst);
var _isObject = require('lodash/isObject');var _isObject2 = _interopRequireDefault(_isObject);
var _toLower = require('lodash/toLower');var _toLower2 = _interopRequireDefault(_toLower);
var _parkingConverter = require('./parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);
var _windDirection = require('../helpers/windDirection');
var _constants = require('../constants');
var _getLocalizedData2 = require('./getLocalizedData');var _getLocalizedData3 = _interopRequireDefault(_getLocalizedData2);
var _findMappedLocalization = require('./cities/findMappedLocalization');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var isHebrew = function isHebrew(locale) {return locale === 'he';};

var composeHebrewSearchTitle = exports.composeHebrewSearchTitle = function composeHebrewSearchTitle(titleObject, translate, searchTargetTitle) {
  var searchTitle = [];
  if (titleObject.types) {
    searchTitle.push(titleObject.types);
  } else {
    searchTitle.push('' + translate('SEOsearch', searchTargetTitle));
  }
  if (titleObject.rooms) {
    searchTitle.push(titleObject.rooms);
  }

  searchTitle.push(titleObject.optionType);
  if (titleObject.location) {
    searchTitle.push(titleObject.location);
  }

  return searchTitle.join(' ');
};

var composeEnglishSearchTitle = exports.composeEnglishSearchTitle = function composeEnglishSearchTitle(titleObject, translate, searchTargetTitle) {
  var searchTitle = [];

  if (titleObject.rooms) {
    searchTitle.push(titleObject.rooms);
  }

  if (titleObject.types) {
    searchTitle.push(titleObject.types);
  } else {
    searchTitle.push('' + translate('SEOsearch', searchTargetTitle));
  }

  searchTitle.push(titleObject.optionType);

  if (titleObject.location) {
    searchTitle.push(titleObject.location);
  }

  return (0, _upperFirst2.default)(searchTitle.join(' '));
};

var formatSearchTitle = exports.formatSearchTitle = function formatSearchTitle() {var routeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var translate = arguments[1];var customParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var

  locale =




  routeData.locale,optionType = routeData.optionType,_routeData$params = routeData.params,params = _routeData$params === undefined ? {} : _routeData$params,_routeData$locationSe = routeData.locationSearch,locationSearch = _routeData$locationSe === undefined ? {} : _routeData$locationSe,section = routeData.location;

  var titleObj = {};

  var isProjects = section === 'projects';

  if (!(0, _isEmpty2.default)(params.rooms)) {
    if (params.rooms.length === 1) {
      titleObj.rooms = (0, _head2.default)(params.rooms) + ' ' + translate('SEOsearch', 'rooms');
    } else {
      titleObj.rooms =
      (0, _head2.default)(params.rooms) + '-' + (0, _last2.default)(params.rooms) + ' ' + translate('SEOsearch', 'rooms');
    }
  }

  if (!(0, _isEmpty2.default)(params.types)) {
    var localizedType = '';
    var realEstateTranslationKey = section === 'commercial' ? 'realEstateCommercial' : 'realEstateApartments';
    var realEstateApartments = customParams.realEstateApartments ?
    customParams.realEstateApartments :
    translate('SEOsearch', realEstateTranslationKey);

    if (params.types.length === 1) {
      var propType = translate('propertyTypesPlural', params.types[0]);

      localizedType = customParams.realEstateApartments ?
      propType.toLowerCase() :
      propType;
    } else {
      localizedType = isProjects ? customParams.projects : realEstateApartments;
    }
    titleObj.types = localizedType;
  }

  if (optionType) {
    titleObj.optionType = '' + translate('SEOsearch', 'optionType', optionType);
  }

  var mappedLocation = (0, _findMappedLocalization.getMappedLocation)(locationSearch, locale);
  if (mappedLocation) {
    titleObj.location = (0, _findMappedLocalization.formatLocation)(mappedLocation, translate, locale);
  }

  var searchTitle = '';
  var searchTargetTitle = '';

  switch (section) {
    case 'projects':{
        searchTargetTitle = 'projects';
        break;
      }
    case 'commercial':{
        searchTargetTitle = 'realEstateCommercial';
        break;
      }
    default:{
        searchTargetTitle = 'realEstateApartments';
        break;
      }}


  if (isHebrew(locale)) {
    searchTitle = composeHebrewSearchTitle(titleObj, translate, searchTargetTitle);
  } else {
    searchTitle = composeEnglishSearchTitle(titleObj, translate, searchTargetTitle);
  }

  return searchTitle;
};

var formatSearchDescription = exports.formatSearchDescription = function formatSearchDescription() {var routeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var translate = arguments[1];var

  locale =




  routeData.locale,optionType = routeData.optionType,_routeData$params2 = routeData.params,params = _routeData$params2 === undefined ? {} : _routeData$params2,_routeData$locationSe2 = routeData.locationSearch,locationSearch = _routeData$locationSe2 === undefined ? {} : _routeData$locationSe2,location = routeData.location;

  var description1 = []; // long sentence, broken into 2 parts
  var description2 = [];

  var searchTargetTitle = location === 'projects' ? 'projects' : 'realEstateApartments';

  if (locale !== _constants.language.default && !(0, _isEmpty2.default)(params.rooms)) {
    description1.push((0, _head2.default)(params.rooms) + '-' + (0, _last2.default)(params.rooms) + ' ' + translate('SEOsearch', 'rooms'));
  }

  if (!(0, _isEmpty2.default)(params.types) && params.types.length === 1) {
    var propType = translate('propertyTypes', params.types[0]);
    description1.push(translate('propertyTypesPlural', params.types[0]));
    description2.push(translate('SEOsearch', 'searchForYour'));
    description2.push((0, _lowerFirst2.default)(propType));
  } else {
    description1.push(translate('SEOsearch', searchTargetTitle));
    description2.push(translate('SEOsearch', 'searchFor'));
    description2.push(translate('SEOsearch', searchTargetTitle));
  }

  if (locale === _constants.language.default && !(0, _isEmpty2.default)(params.rooms)) {
    description1.push((0, _head2.default)(params.rooms) + '-' + (0, _last2.default)(params.rooms) + ' ' + translate('SEOsearch', 'rooms'));
  }

  if (optionType) {
    description1.push('' + translate('SEOsearch', 'optionType', optionType));
  }

  description2.push(translate('SEOsearch', 'descriptionContinue'));

  var mappedLocation = (0, _findMappedLocalization.getMappedLocation)(locationSearch, locale);
  if (mappedLocation) {
    description1.push((0, _findMappedLocalization.formatLocation)(mappedLocation, translate, locale));
    description2.push((0, _findMappedLocalization.formatLocation)(mappedLocation, translate, locale));
  }

  description1.push(translate('SEOsearch', 'from'));

  return (0, _upperFirst2.default)(description1.join(' ') + ' ' + description2.join(' '));
};

var formatPropertyTitle = exports.formatPropertyTitle = function formatPropertyTitle(property, propertyType, translate, locale) {
  if (!property || !propertyType) {
    return null;
  }

  var isLand = property.isLand || property.property_type === 'land'; // temp patch
  var rooms = property.additional_info.rooms;
  var lang = property.address[locale] ? locale : _constants.language.fallback;var _property$address$lan =




  property.address[lang],streetName = _property$address$lan.street_name,houseNumber = _property$address$lan.house_number,cityName = _property$address$lan.city_name;var
  hide_house_number = property.address.hide_house_number;
  var fullAddress = streetName + ' ' + (hide_house_number ? '' : houseNumber || '') + ' ' + cityName;
  var roomsTitle = rooms && !isLand ? rooms + ' ' + translate('SEOTitle', 'rooms') + ' ' : '';

  return propertyType + ' ' + translate('SEOTitle', property.search_option) + ' ' + roomsTitle + translate('SEOTitle', 'in') + fullAddress;
};

var formatProjectTitle = exports.formatProjectTitle = function formatProjectTitle(project, translate, locale) {
  if (!project) {
    return null;
  }var _getLocalizedData =

  (0, _getLocalizedData3.default)(project.address, locale, true),address = _getLocalizedData.result;var

  streetName =


  address.street_name,houseNumber = address.house_number,cityName = address.city_name;
  var fullAddress = streetName + ' ' + (houseNumber || '') + ' ' + cityName;

  return translate('ProjectDetails', 'project') + ' ' + translate('propertyDetails', 'SEOTitle', 'in') + fullAddress;
};

var formatPropertyDescription = exports.formatPropertyDescription = function formatPropertyDescription(property, translate) {var _property$additional_ =
















  property.additional_info;_property$additional_ = _property$additional_ === undefined ? {} : _property$additional_;var parking = _property$additional_.parking,areaObject = _property$additional_.area,_property$additional_2 = _property$additional_.floor,floor = _property$additional_2 === undefined ? { on_the: 0, out_of: 0 } : _property$additional_2,year = _property$additional_.construction_year,elevators = _property$additional_.elevators,balconies = _property$additional_.balconies,entryDateObject = _property$additional_.entry_date,windDirection = _property$additional_.light_direction,commodities = property.commodities,isLand = property.isLand;

  var entryDate = (0, _isObject2.default)(entryDateObject) ? entryDateObject.date : entryDateObject; // for migrating purposes
  var area = (0, _isObject2.default)(areaObject) ? areaObject.base : areaObject; // for migration purposes

  var descriptionCollectiion = [];
  var commoditiesCollection = [];

  descriptionCollectiion.push(translate('area') + ' ' + area + ' ' + translate('square'));

  if (!isLand) {
    descriptionCollectiion.push(translate('floor') + ' ' + floor.on_the);
  }

  if ((0, _parkingConverter2.default)(parking) !== 0) {
    descriptionCollectiion.push(
    (0, _parkingConverter2.default)(parking) === 1 ?
    translate('parkingSpot') :
    (0, _parkingConverter2.default)(parking) + ' ' + translate('parkingSpots'));

  }
  if (year) {
    descriptionCollectiion.push(translate('constructionYear') + ' ' + year);
  }

  if (elevators && elevators !== 0) {
    descriptionCollectiion.push(
    elevators === 1 ?
    translate('elevator') :
    elevators + ' ' + translate('elevators'));

  }

  if (balconies && balconies !== 0) {
    descriptionCollectiion.push(
    balconies === 1 ?
    translate('balcony') :
    balconies + ' ' + translate('balconies'));

  }
  if (entryDate) {
    descriptionCollectiion.push(translate('entryDate') + ': ' + (0, _moment2.default)(entryDate).format('DD/MM/YYYY'));
  }

  if (windDirection) {
    var amount = (0, _windDirection.windDirectionsAmount)(windDirection);
    if (amount !== 0) {
      descriptionCollectiion.push(translate('directionsOfTheWind') + ': ' + amount);
    }
  }

  if (commodities && commodities.length > 0) {
    descriptionCollectiion.push('' + translate('commodities'));
    commodities.forEach(function (commodity) {return commoditiesCollection.push('' + translate(commodity));});
  }
  var descriptionString = descriptionCollectiion.join(', ');

  if (commoditiesCollection.length > 0) {
    descriptionString = descriptionString + ': ' + commoditiesCollection.join(', ');
  }
  return (0, _upperFirst2.default)((0, _toLower2.default)(descriptionString));
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatSEOData.js
// module id = 77
// module chunks = 0